import React from "react";
import { Link } from "react-router-dom";
import bloglogo from "../../componets/assets/images/blog.png";
import { FaUser, FaEnvelope } from "react-icons/fa";

export default function NavBar() {
  const links = [
    {
      id: "home",
      to: "/",
      text: "Profile",
      icon: <FaUser className="text-md text-zinc-700" />,
    },
    {
      id: "blog",
      to: "mailto:mandlambolekwa@gmail.com",
      text: "Contact",
      icon: <FaEnvelope className="text-md text-zinc-700" />,
    },
  ];

  return (
    <nav className="flex fixed flex-row  bg-[#e9e2db] justify-between w-full items-center px-2 md:px-10 py-3 md:py-1 border-b border-black">
      <div className="hidden md:block">
        <img className="w-20" src={bloglogo} />
      </div>
      <div className="flex flex-row items-center gap-3 md:hidden lg:flex">
        <h1 className="text-[#326b43] font-medium text-xs">Mandla Mbolekwa</h1>
        <div className="relative h-0.5 md:w-40 w-20 bg-black"></div>
      </div>
      <div className="flex flex-row items-center space-x-5">
        {links.map((link) =>
          link.to.startsWith("mailto") ? (
            <a
              key={link.id}
              href={link.to}
              target="_blank"
              className=" bg-[#dac39d] cursor-pointer rounded-lg py-1 px-3 flex flex-col justify-center items-center border-black"
            >
              {link.icon}
              <h1 className="hidden md:block mt-0.5 text-[10px] text-black hover:text-black transition-colors duration-300">
                {link.text}
              </h1>
            </a>
          ) : (
            <Link
              key={link.id}
              to={link.to}
              
              className=" bg-[#dac39d] rounded-lg py-1 px-3 flex flex-col justify-center items-center border-black"
            >
              {link.icon}
              <h1 className="hidden md:block mt-0.5 text-[10px] text-black hover:text-black transition-colors duration-300">
                {link.text}
              </h1>
            </Link>
          ),
        )}
      </div>
    </nav>
  );
}
